/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
export function bValidExpiration(expirationDate: string) {
    const month = expirationDate.slice(0, 2);
    const year = expirationDate.slice(3, 5);
    const yearToday = new Date().toLocaleDateString().slice(8, 10);

    if (Number(month) > 12 || Number(month) < 0) return false;

    if (Number(year) < Number(yearToday)) return false;

    return true;
}